export enum LocalStorageKeys {
  TimeSinceAmountSavedToast = 'timeSinceAmountSavedToast',
}

export const setItemInLocalStorage = (key: LocalStorageKeys, value: string) => {
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(key, value);
    } catch (error) {}
  }
};

export const getItemFromLocalStorage = (key: LocalStorageKeys) => {
  if (typeof window !== 'undefined') {
    try {
      return localStorage.getItem(key);
    } catch (error) {}
  }
  return null;
};
